export default {"src":"/_next/static/media/ic-blurred-bg-filled-red-cross.a0365deb.svg","height":110,"width":111};